import Hero from '../components/Hero';
import Verticals from '../components/Verticals';
import HowItWorks from '../components/HowItWorks';
import HostSection from '../components/HostSection';
import Dashboard from '../components/Dashboard';
import { Gallery, Trusted } from '../components/Showcase';
import CTA from '../components/CTA';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Verticals />
      <Dashboard />
      <HowItWorks />
      <HostSection />
      <Gallery />
      <Trusted />
      <CTA />
    </>
  );
}
